import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Paho } from 'ng2-mqtt/mqttws31';
import { ConfigService } from './config.service';
import * as myGlobals from './globals';

@Injectable({
  providedIn: 'root'
})
export class MqttServiceService {
  private _client: Paho.MQTT.Client;
  public missionAnnounced$ = new Subject<any>();
  private mqttOptions = {
    userName: myGlobals.MQTT_USERNAME,
    password: myGlobals.MQTT_PASSWORD,
    useSSL: myGlobals.MQTT_USESSL,
    timeout: 60,
    keepAliveInterval: 60,
    onSuccess: mqtt => this.onSuccess(mqtt),
    onFailure: e => this.onMqttConnectionLost(e)
  };

  private subscribedIds = [];

  constructor(private _cookie: ConfigService) {
  }
  mqttConnection() {
    this.mqttOptions = {
      userName: myGlobals.MQTT_USERNAME,
      password: myGlobals.MQTT_PASSWORD,
      useSSL: myGlobals.MQTT_USESSL,
      timeout: 60,
      keepAliveInterval: 60,
      onSuccess: mqtt => this.onSuccess(mqtt),
      onFailure: e => this.onMqttConnectionLost(e)
    };
    this._client = new Paho.MQTT.Client(
      myGlobals.MQTT_HOST,
      'myClientId' + new Date().getTime()
    );
    this._client.onMessageArrived = message => {
      this.onMqttMessageArrived(message.payloadString);
    };

    this._client.onConnectionLost = response => {
      this.onMqttConnectionLost(response);
    };
    console.log('connection is mqtt');
    !this._client.isConnected() ? this._client.connect(this.mqttOptions) : '';
  }
  onSuccess(mqtt) {
    let cityId = '';
    if (this._cookie.getCityId('cityid') == '0') {
      cityId = '';
    } else {
      cityId = this._cookie.getCityId('cityid') + '/';
    }
    let operatorId = '';
    if (this._cookie.getOperatorId('operatorid') == '0') {
      operatorId = '';
    } else {
      operatorId = this._cookie.getOperatorId('operatorid') + '/';
    }
    // subscribing to dispatcher & godsview channel
    this._client.subscribe(
      this._cookie.getItem('dispatchermqtt') + cityId + operatorId + '#',
      { qos: 2 }
    );
    this._client.subscribe(
      this._cookie.getItem('dispatchermqtt') + cityId + '#',
      { qos: 2 }
    );
    // this._client.subscribe('godsview/' + cityId + operatorId + '#', { qos: 2 });
    const temp = `${this._cookie.getItem(
      'dispatchermqtt'
    )}${cityId}${operatorId}#`;
    this.subscribedIds.push(temp);
    this.subscribedIds = Array.from(new Set(this.subscribedIds));
    console.log('MQTT OnSuccess ', cityId, this.subscribedIds);
  }

  private onMqttConnectionLost(response) {
    console.log('onConnectionLost', response);
    if (response.errorCode !== 0) {
      // console.log('onConnectionLost:' + response.errorMessage);
      const temp = {
        userName: myGlobals.MQTT_USERNAME,
        password: myGlobals.MQTT_PASSWORD,
        useSSL: myGlobals.MQTT_USESSL,
        timeout: 60,
        keepAliveInterval: 60,
        onSuccess: mqtt => this.onSuccess(mqtt),
        onFailure: e => this.onMqttConnectionLost(e)
      };
      this._client.connect(temp);
    }
  }

  private onMqttMessageArrived(message: string) {
    console.log('MQTT SERVICE', JSON.parse(message));
    this.missionAnnounced$.next(message);
  }

  announceMqtt(data: string) {
    const temp = JSON.parse(data);
    console.log('connection is ')
    if (temp.status === 99) {
      this.subscribedIds.forEach(subid => {
        console.log('UnSubscribed From ', subid);
        this._client.unsubscribe(subid, {});
      });
      temp.cityId == '0' ? temp.cityId = '' : '';
      this._client.subscribe(
        this._cookie.getItem('dispatchermqtt') + temp.cityId + '#',
        { qos: 2 }
      );

      // this._client.subscribe(
      //   this._cookie.getItem('dispatchermqtt') + temp.cityId + operatorId + '#',
      //   { qos: 2 }
      // );
      // this._client.subscribe('godsview/' + temp.cityId + '#', { qos: 2 });
      const id = `${this._cookie.getItem('dispatchermqtt')}${temp.cityId}#`;
      this.subscribedIds.push(id);
      this.subscribedIds = Array.from(new Set(this.subscribedIds));
    }
    this.missionAnnounced$.next(data);
  }
  mqttDisconnect() {
    this.subscribedIds.forEach(subid => {
      console.log('UnSubscribed From ', subid);
      this._client.unsubscribe(subid, {});
      this._client.isConnected() ? this._client.disconnect() : '';
    });
    this.subscribedIds = [];
  }
}
